import { Component } from 'react';

/**
 * Fängt Render-Fehler ab, damit statt einer weißen Seite eine Meldung
 * erscheint (Issue #18).
 */
export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unerwarteter Render-Fehler:', error, info?.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div className="min-h-screen flex items-center justify-center px-4">
        <div className="card max-w-md w-full text-center space-y-3">
          <p className="text-2xl" aria-hidden="true">🫧</p>
          <p className="font-semibold text-gray-800">Da ist etwas schiefgelaufen</p>
          <p className="text-sm text-gray-500">
            Die Ansicht konnte nicht dargestellt werden. Bitte die Seite neu laden —
            bleibt der Fehler bestehen, bitte dem Ausbilder Bescheid geben.
          </p>
          <p className="text-xs text-gray-400 font-mono break-words">{this.state.error.message}</p>
          <button onClick={() => window.location.reload()} className="btn-primary w-full">
            Neu laden
          </button>
        </div>
      </div>
    );
  }
}
